import SuccessIcon from "../../../assets/images/success.svg";
import { useStateContext } from "../../../contexts/ContextProvider";

const Success = ({ heading, para }) => {
  const { success, setSuccess } = useStateContext();
  // const navigate = useNavigate();

  // const handleRedirect = () => {
  //   setSuccess(false);
  //   navigate(redirect);
  // };

  const handleCloseModal = () => setSuccess(false);

  return (
    <>
      <div
        className={`${
          success
            ? "deleteModal successModal visible"
            : "deleteModal successModal hidden"
        }`}
      >
        <div className="flex">
          <div className="icon">
            <img src={SuccessIcon} alt="" />
          </div>
          <div className="content">
            <span className="heading">{heading}</span>
            <span className="para">{para}</span>
          </div>
        </div>
        <div className="action">
          {/* <span className="cancel" onClick={handleRedirect}>
            View
          </span> */}
          <span className="delete" onClick={handleCloseModal}>
            Close
          </span>
        </div>
      </div>
    </>
  );
};

export default Success;
